import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { jwtDecode } from "jwt-decode";

const RiseTicket = () => {
  const tableRef = useRef(null);
  const [tickets, setTickets] = useState([]);
  const [userRole, setUserRole] = useState(null); // State for role
  
  useEffect(() => {
      const token = localStorage.getItem("authToken");
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          setUserRole(parseInt(decodedToken.RoleBaseId)); // Update state with role
        } catch (error) {
          console.error("Error decoding token:", error);
          localStorage.removeItem("authToken"); // Remove invalid token
        }
      }
    }, []); // Runs only on mount
 
    useEffect(() => {
      const fetchTickets = async () => {
        if (userRole === null) return; // Wait until userRole is set
    
        const authToken = localStorage.getItem("authToken");
        let fetchedTickets = [];
    
        try {
          if (userRole === 1) {
            // Admin: Fetch both active and closed tickets
            //const activeResponse = await fetch("http://localhost:5121/api/RiseTicket/active", {
            const activeResponse = await fetch("https://apiv2.chakran.in/api/RiseTicket/active", {
              headers: { Authorization: `Bearer ${authToken}` },
            });
            //const closedResponse = await fetch("http://localhost:5121/api/RiseTicket/closed", {
            const closedResponse = await fetch("https://apiv2.chakran.in/api/RiseTicket/closed", {
              headers: { Authorization: `Bearer ${authToken}` },
            });
    
            if (!activeResponse.ok || !closedResponse.ok) throw new Error("Failed to fetch tickets");
    
            const activeData = await activeResponse.json();
            const closedData = await closedResponse.json();
    
            fetchedTickets = [...activeData, ...closedData]; // Merge both for admin
          } else {
            // Non-Admin: Fetch only closed tickets
            //const closedResponse = await fetch("http://localhost:5121/api/RiseTicket/closed", {
            const closedResponse = await fetch("https://apiv2.chakran.in/api/RiseTicket/closed", {
              headers: { Authorization: `Bearer ${authToken}` },
            });
    
            if (!closedResponse.ok) throw new Error("Failed to fetch closed tickets");
            fetchedTickets = await closedResponse.json();
          }
    
          setTickets(fetchedTickets); // Update table data
    
        } catch (error) {
          console.error("Error fetching tickets:", error.message);
        }
      };
    
      fetchTickets();
    }, [userRole]); // Refetch when userRole updates

    console.log(tickets);

    // Function to update ticket status
    const handleStatusChange = async (ticketId, newStatus) => {
      console.log("Selected Ticket ID:", ticketId);
      console.log("New Status:", newStatus);
    
      try {
        const authToken = localStorage.getItem("authToken");
    
        //const response = await fetch(`http://localhost:5121/api/RiseTicket/updateStatus/${ticketId}`, {
        const response = await fetch(`https://apiv2.chakran.in/api/RiseTicket/updateStatus/${ticketId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({ status: newStatus }),
        });
    
        if (!response.ok) throw new Error("Failed to update ticket status");
    
        // Update UI state
        setTickets((prevTickets) =>
          prevTickets.map((ticket) =>
            ticket.ticketId === parseInt(ticketId) ? { ...ticket, status: newStatus } : ticket
          )
        );
    
      } catch (error) {
        console.error("Error updating ticket status:", error);
      }
    };
    

    
  // Initialize DataTable
  useEffect(() => {
    if (tableRef.current && tickets.length > 0) {
      const table = $(tableRef.current).DataTable({
        data: tickets,
        columns: [
          { data: "subject", title: "Ticket" },
          { data: "message", title: "Message" },
          { data: "startDate", title: "Date" },
          {
            title: "Status",
            data: "status",
            render: function (data, type, row) {
              if (userRole === 1) {
                return `
                <div className="form-group">
                  <select className="form-control status-dropdown" data-id="${row.ticketId}">
                    <option value="Active" ${data === "Active" ? "selected" : ""}>Active</option>
                    <option value="Closed" ${data === "Closed" ? "selected" : ""}>Closed</option>
                  </select>
                `;
              }
              return data;
            },
          },
        ],
        destroy: true,
      });
  
      // Handle status change event
      $(tableRef.current).on("change", ".status-dropdown", function () {
      const ticketId = $(this).attr("data-id"); // Correctly extract ticketId
      const newStatus = $(this).val();

      console.log("Selected Ticket ID:", ticketId); // Log Ticket ID
      console.log("New Status:", newStatus); // Log New Status

      handleStatusChange(ticketId, newStatus);
      });
  
      return () => {
        table.destroy();
        $(tableRef.current).off("change", ".status-dropdown");
      };
    }
  }, [tickets, userRole]);
  

  return (
   <>
      <div className="container">
        <div className="card card-default card-profile px-6 py-4">
          <div className="row ">
            <div className="test-left col-md-6">
              <h2 className="h5 d-block mt-3 mb-2 " >My tickets</h2>
            </div>
            <div className="profile-button col-md-6 text-right">
              <Link className="btn btn-primary btn-pill" to="/dashboard/open-new-ticket">Open New Ticket</Link>
            </div>
            <div className="col-md-12">
              <div className="card card-default">
                  <div className="px-6 py-4">
                  <h3 className="font-weight-bold">Need Assistance?</h3>
                    <p>For email support, please use the "Open new ticket" button to raise a ticket with us.
                    If you require instant help, feel free to call us. </p>
                  </div>
              </div>
            </div>
          </div>
          <div className="card-footer card-profile-footer">
            <ul className="nav nav-border-top justify-content-center">
            {(userRole === 1)&&(
              <li className="nav-item">
                <Link className="nav-link btmBorder" to="/dashboard/rise-ticket" >Active Ticket</Link>
              </li>
            )}
            {(userRole === 2 || userRole === 3)&&(
              <li className="nav-item">
                <Link className="nav-link" to="/dashboard/close-ticket">Close Ticket</Link>
              </li>
               )}
            </ul>
          </div>
        </div>
         <div className="row">
                  <div className="col-12">
                    <div className="card card-default">
                      <div className="card-body">
                        <table ref={tableRef} id="productsTable" className="table table-bordered table-hover table-product" style={{ width: '100%' }}>
                          <tbody>
                            <tr>
                              <th>Subject</th>                                                         
                              <th>Message</th>                             
                              <th>Date</th> 
                              <th>Status</th>                                                   
                            </tr>
                            
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            
             
             
            
       
   </>
  );
};

export default RiseTicket;
